<template>
    <div>
        <progress-header />

        <taxi-search-form
            offer-type="fat"
            :split-adults-children="true"
            :initial-params="searchFormParams"
            @search="search"
            @startPlacesFetched="startPlacesFetched"
            @endPlacesFetched="endPlacesFetched"
        />

        <search-tips type="fat" />
    </div>
</template>

<script>
    import TaxiSearchForm from '@components/Taxi/TaxiSearchForm';
    import ProgressHeader from './components/ProgressHeader';
    import {mapGetters} from 'vuex';
    import { PASSENGER_TYPE_ADULT, PASSENGER_TYPE_CHILD } from '@/constants';
    import {trackGA} from '@utilities/tracking';
    import SearchTips from '@components/SearchTips';

    export default {
        components: {
            TaxiSearchForm,
            ProgressHeader,
            SearchTips,
        },

        data() {
            return {
                trackingName: 'Smart Taxi',
            };
        },

        created () {
            trackGA('view_item', {
                'items': [
                    {
                        id: window.location.pathname,
                        name: this.trackingName,
                        quantity: 1,
                    },
                ],
            });
            trackGA('checkout_progress', {
                checkout_step: 1,
                checkout_option: window.location.pathname,
            });
        },

        computed: {
            ...mapGetters({
                searchParams: 'familyAirportTaxi/searchParameters',
                passengersNumber: 'familyAirportTaxi/passengersNumber',
                startPlaces: 'familyAirportTaxi/startPlaces',
                endPlaces: 'familyAirportTaxi/endPlaces',
            }),

            searchFormParams() {
                const parameters = {
                    ...this.searchParams,
                };

                if (this.searchParams) {
                    parameters.start_place = {
                        placeId: this.searchParams.start_place_id,
                        start_place: this.searchParams.start_place,
                        start_is_airport: this.searchParams.start_is_airport,
                    };

                    parameters.end_place = {
                        placeId: this.searchParams.end_place_id,
                        end_place: this.searchParams.end_place,
                        end_is_airport: this.searchParams.end_is_airport,
                    };

                    parameters.passengers = this.searchParams.passengers;
                }

                return {
                    parameters,
                    startPlaces: this.startPlaces,
                    endPlaces: this.endPlaces,
                };
            },
        },

        methods: {
            search(params) {
                this.$store.dispatch('familyAirportTaxi/reset').then(() => {
                    const passengersAdult = params.passengers.find((passenger) => {
                        return passenger.type === PASSENGER_TYPE_ADULT;
                    });

                    const passengersChild = params.passengers.find((passenger) => {
                        return passenger.type === PASSENGER_TYPE_CHILD;
                    });

                    const query = {... params};
                    query.passengers_adult = passengersAdult.quantity;
                    query.passengers_child = passengersChild.quantity;
                    this.$router.push({
                        name: 'smart-taxi.search',
                        query: query,
                    });
                });
            },

            startPlacesFetched(data) {
                this.$store.dispatch('familyAirportTaxi/setStartPlaces', data);
            },

            endPlacesFetched(data) {
                this.$store.dispatch('familyAirportTaxi/setEndPlaces', data);
            },
        },
    };
</script>
